// extracted by mini-css-extract-plugin
export default {"paginationContainer":"pagination_paginationContainer__PqkAt","pages":"pagination_pages__PXce7","pageButton":"pagination_pageButton__VtvmG","active":"pagination_active__H20AH"};